import { meetingsAction, meetingsState } from "./types";
import { actions } from './actions';

export function meetingStoreReducer(state: meetingsState, action: meetingsAction): meetingsState {
	switch (action.type) {
		case 'SET_SCROLL_POSITION':
			return actions.setScrollPosition(state, action.payload);
		case 'SET_SEARCH_QUERY':
			return actions.setSearchQuery(state, action.payload);
		case 'SET_PAGE_NUMBER':
			return actions.setPageNumber(state, action.payload);
		case 'RESET_PAGE_SETTINGS':
			return actions.resetPageSettings(state);
		case 'SET_SHOW_ORGANIZATIONS':
			return actions.setShowOrganizations(state, action.payload);
		default:
			throw new Error('Unexpected action');
	}
}
